import { render, staticRenderFns } from "./warePosition.vue?vue&type=template&id=901a2a40&scoped=true&"
import script from "./warePosition.vue?vue&type=script&lang=js&"
export * from "./warePosition.vue?vue&type=script&lang=js&"
import style0 from "./warePosition.vue?vue&type=style&index=0&id=901a2a40&style=true&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901a2a40",
  null
  
)

component.options.__file = "warePosition.vue"
export default component.exports